import React, { FC, useMemo, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import Application from 'src/front/components/Application';

import { StepperRefProps } from 'src/front/components/StepperView';

import UploadDocumentProvider from 'src/front/contexts/UploadDocumentContext';
import UploadDocumentList from './UploadDocumentList';
import UploadDocumentSearch from './UploadDocumentSearch';

const UploadDocument: FC = () => {
  const { t } = useTranslation();
  const stepperRef = useRef<StepperRefProps>(null);

  const [isCompleted, setIsCompleted] = useState<boolean>(false);

  const goToNextStep = (): void => stepperRef.current?.goToNextStep();

  const goToPreviousStep = (): void => {
    stepperRef.current?.goToPreviousStep();
  };

  const steps = [
    {
      component: () => <UploadDocumentSearch goToNextStep={goToNextStep} />,
    },
    {
      component: () => (
        <UploadDocumentList goToPreviousStep={goToPreviousStep} setIsCompleted={setIsCompleted} />
      ),
    },
  ];

  const stepsVertical = useMemo(
    () => [
      {
        index: 1,
        text: t('uploadDocuments_stepper_search_text'),
      },
      {
        index: 2,
        text: t('uploadDocuments_stepper_uploadDocuments_text'),
      },
    ],
    [t]
  );

  return (
    <UploadDocumentProvider>
      <Application
        isCompleted={isCompleted}
        stepperRef={stepperRef}
        steps={steps}
        stepsVertical={stepsVertical}
      />
    </UploadDocumentProvider>
  );
};

export default UploadDocument;
